import TabBody from './components/Body';
import TabHeader from './components/Header';

export const Tab = {
	Header: TabHeader,
	Body: TabBody,
};
